import dayjs from 'dayjs';
export default function getWeeksInMonth(monthDate) {
    if (monthDate === void 0) { monthDate = new Date(); }
    var weeks = [];
    var month = dayjs(monthDate);
    var firstDayOfMonth = month.startOf('month');
    var lastDayOfMonth = month.endOf('month');
    var currentDay = firstDayOfMonth.startOf('week');
    while (currentDay <= lastDayOfMonth) {
        var week = [];
        for (var i = 0; i < 7; i++) {
            var day = {
                date: currentDay.startOf('day').toDate(),
                inDisplayedMonth: (currentDay.isSame(firstDayOfMonth) || currentDay.isAfter(firstDayOfMonth)) && (currentDay.isSame(lastDayOfMonth) || currentDay.isBefore(lastDayOfMonth)),
            };
            week.push(day);
            currentDay = currentDay.add(1, 'day');
        }
        weeks.push(week);
    }
    var fillEmptyDays = function (day, week, isDisplayedMonth, isAdding) {
        var count = 7 - week.length;
        for (var i = 0; i < count; i++) {
            var dayObj = {
                date: day.startOf('day').toDate(),
                inDisplayedMonth: isDisplayedMonth,
            };
            isAdding ? week.push(dayObj) : week.unshift(dayObj);
            day = isAdding ? day.add(1, 'day') : day.subtract(1, 'day');
        }
    };
    fillEmptyDays(firstDayOfMonth, weeks[0], false, false);
    fillEmptyDays(lastDayOfMonth, weeks[weeks.length - 1], false, true);
    return weeks;
}
